<app-writer-list
  [loading$]="componentStore.loading$"
  [error$]="componentStore.error$"
  [paginationView$]="componentStore.paginationView$"
  [hasFilters]="false"
  [hasNew]="false"
  (pageEvent)="pageEvent($event)"
>
  <table mat-table [dataSource]="componentStore.entities$ | async">
    <ng-container matColumnDef="owner">
      <th i18n mat-header-cell *matHeaderCellDef>Auteur</th>
      <td mat-cell *matCellDef="let element; dataSource: componentStore.entities$ | async">
        {{ element.owner.username }}
      </td>
    </ng-container>
    <ng-container matColumnDef="rate">
      <th i18n mat-header-cell *matHeaderCellDef>Note</th>
      <td mat-cell *matCellDef="let element; dataSource: componentStore.entities$ | async">
        {{ element.rate }}
      </td>
    </ng-container>
    <ng-container matColumnDef="comment">
      <th i18n mat-header-cell *matHeaderCellDef>Commentaire</th>
      <td mat-cell *matCellDef="let element; dataSource: componentStore.entities$ | async">
        {{ element.comment }}
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="columns"></tr>
    <tr mat-row *matRowDef="let row; columns: columns"></tr>
  </table>
</app-writer-list>
